var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-success",attrs:{"href":_vm.routeToWsp,"target":"_black"}},[_c('i',{staticClass:"fab fa-whatsapp"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }